class NovaHiddenGrid extends HTMLElement {
  constructor() {
    super();

    const items = this.querySelectorAll("[data-item]");
    const maxItems = parseInt(this.getAttribute("data-max-items") || 9, 10);
    const btnShowMore = this.querySelector('[data-btn="show-more"]');
    const btnShowMoreContent = this.querySelector('[data-btn="content"]');
    let isVisible = false;

    if (!items) {
      throw new Error("Element with [data-item] is missing");
    }

    if (!maxItems) {
      throw new Error("Attribute data-max-items is missing");
    }

    if (!btnShowMore) {
      throw new Error('Element with [data-btn="show-more"] is missing');
    }

    if (!btnShowMoreContent) {
      throw new Error('Element with [data-btn="content"] is missing');
    }

    if (items.length > maxItems) {
      items.forEach((item, index) => {
        if (index >= maxItems) {
          item.setAttribute("data-hidden", "true");
        }
      });

      btnShowMore.addEventListener("click", () => {
        if (isVisible) {
          items.forEach((item, index) => {
            if (index >= maxItems) {
              item.setAttribute("data-hidden", "true");
            }
          });
          btnShowMoreContent.textContent = this.getAttribute("data-show-more-label") || "Voir plus";
          btnShowMore.setAttribute("data-active", "false");
        } else {
          items.forEach(item => {
            item.removeAttribute("data-hidden");
          });
          btnShowMoreContent.textContent = this.getAttribute("data-show-less-label") || "Voir moins";

          btnShowMore.setAttribute("data-active", "true");
        }
        isVisible = !isVisible;
      });
    } else {
      btnShowMore.setAttribute("data-hidden", "true");
    }
  }
}

if (!customElements.get("nova-hidden-grid")) {
  customElements.define("nova-hidden-grid", NovaHiddenGrid);
}
